(function($){
$(function(){  //document.ready

    $(".socialshareclick").click(function(){
      $(".socialshare .socialwrap").toggle();
    });

    if ($('html').attr('lang') !== 'ar') $('.mobile-facets__open-label').html('Filter');

    //Remove product count from text
    $('li.facets__item span[aria-hidden="true"], li.mobile-facets__item span[aria-hidden="true"]').each(function() {
      var text = $(this).text();
      var newText = text.replace(/\s*\([^)]*\)/, '');
      $(this).text(newText);
    });
  


});
})(jQuery);
